(function () {
  function initHurryUpInventory(root) {
    var inventoryEl = root.querySelector('.ProductForm__Inventory');
    var containerEl = root.querySelector('#hurryUpContainer');

    if (!inventoryEl || !containerEl) {
      return;
    }

    function syncContainerVisibility() {
      if (inventoryEl.style.display === 'none') {
        containerEl.style.display = 'none';
      } else if (inventoryEl.textContent.trim()) {
        containerEl.style.display = 'block';
      }
    }

    syncContainerVisibility();

    var observer = new MutationObserver(function (mutationsList) {
      for (var i = 0; i < mutationsList.length; i++) {
        var mutation = mutationsList[i];

        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          syncContainerVisibility();
          inventoryEl.style.color = 'red';
          setTimeout(function () {
            inventoryEl.style.color = '#3f3f3f';
          }, 1500);
        }
      }
    });

    observer.observe(inventoryEl, { childList: true, characterData: true, subtree: true });
  }

  function initAll() {
    document.querySelectorAll('.product-block--hurry-up').forEach(initHurryUpInventory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
